import { Ds } from "@accurx/design";

export const MissingSnomedCodeInformation = () => (
    <Ds.Text>
        If you can't find a code, you can{" "}
        <Ds.Link href="https://forms.gle/WhLWuczWsniGqAUUA" target="_blank">
            send a request
        </Ds.Link>
    </Ds.Text>
);
